import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PlatformDataService } from '@zhik/core/services/platform-data';
import { ShellComponent } from './core/components/shell/shell.component';

@Component({
  imports: [ShellComponent, RouterOutlet],
  selector: 'dskhome-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  protected readonly platformDataService = inject(PlatformDataService);
}
